export { default } from "bullitttime-embermodelsevent/adapters/timing-impulse";
